export { default, meta } from "./routes/forgot-password.tsx";